<template>
  <div class="evaluationStaffTrainingDetail">
    <div class="common_content">
      <el-card class="box-card">
        <div slot="header">
          <el-tabs
            v-model="activeName"
            type="card"
            v-if="data[0] !== undefined"
          >
            <el-tab-pane label="基本信息" name="first">
              <div class="content">
                <el-form label-width="100px">
                  <el-form-item label="培训名称：">
                    <span>{{ data[0].trainClassName }}</span>
                  </el-form-item>
                  <el-form-item label="培训类型：">
                    <span>{{ data[0].trainType }}</span>
                  </el-form-item>
                  <el-form-item label="培训等级：">
                    <span>{{ data[0].grade | grade }}</span>
                  </el-form-item>
                  <el-form-item label="报名类型：">
                    <el-radio-group
                      v-model="feeType"
                      v-for="(item, index) in feeTypeOptions"
                      :key="index"
                    >
                      <el-radio :label="item.value">{{ item.label }}</el-radio>
                      <br />
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="培训费用：">
                    <span>￥{{ testFee }}</span>
                  </el-form-item>
                  <el-form-item label="报名时间：">
                    <span
                      >{{ data[0].startTime | dateformat("YYYY-MM-DD HH:mm") }}
                      至
                      {{
                        data[0].endTime | dateformat("YYYY-MM-DD HH:mm")
                      }}</span
                    >
                  </el-form-item>
                  <el-form-item label="培训时间：">
                    <span
                      >{{
                        data[0].opening_class_start_time
                          | dateformat("YYYY-MM-DD HH:mm")
                      }}
                      至
                      {{
                        data[0].opening_class_end_time
                          | dateformat("YYYY-MM-DD HH:mm")
                      }}</span
                    >
                  </el-form-item>
                  <el-form-item label="培训地址：">
                    <span
                      >{{
                        data[0].provinceName == data[0].cityName
                          ? data[0].provinceName
                          : data[0].provinceName + data[0].cityName
                      }}{{ data[0].districtName
                      }}{{ data[0].detail_addr }}</span
                    >
                  </el-form-item>
                  <el-form-item label="培训资质：" v-if="data[0].grade != 3">
                    <el-radio-group
                      v-model="aptitude"
                      v-for="(item, index) in data[0].aptitude_recording"
                      :key="index"
                    >
                      <el-radio :label="index" @change="change">{{
                        item.value
                      }}</el-radio>
                      <br />
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="上传资质：" v-if="aptitude">
                    <el-upload
                      class="avatar-uploader"
                      action="#"
                      accept=".png, .jpeg, .jpg"
                      :auto-upload="false"
                      :multiple="false"
                      :show-file-list="false"
                      :on-change="loadJsonFromFile"
                    >
                      <img
                        v-if="imageUrl"
                        :src="imageUrl"
                        class="avatar"
                        @mouseover="imgMouseover"
                      />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      <div
                        class="el-upload-show"
                        :style="active"
                        @mouseleave="imgMouseleave"
                      >
                        <span class="el-upload-span1">
                          <span
                            class="el-upload-list__item-preview"
                            @click.stop="handlePictureCardPreview()"
                          >
                            <i class="el-icon-zoom-in"></i>
                          </span>
                          <span @click.stop="handleRemove()">
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>
                      </div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </el-form-item>
                  <el-form-item label="上传学历：" v-if="imgaptitude">
                    <el-upload
                      class="avatar-uploader"
                      action="#"
                      accept=".png, .jpeg, .jpg"
                      :auto-upload="false"
                      :multiple="false"
                      :show-file-list="false"
                      :on-change="loadJsonFromFile"
                    >
                      <img
                        v-if="imageUrl"
                        :src="imageUrl"
                        class="avatar"
                        @mouseover="imgMouseover"
                      />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      <div
                        class="el-upload-show"
                        :style="active"
                        @mouseleave="imgMouseleave"
                      >
                        <span class="el-upload-span1">
                          <span
                            class="el-upload-list__item-preview"
                            @click.stop="handlePictureCardPreview()"
                          >
                            <i class="el-icon-zoom-in"></i>
                          </span>
                          <span @click.stop="handleRemove()">
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>
                      </div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </el-form-item>
                  <el-form-item label="报名提示：">
                    <el-checkbox v-model="checked"
                      >资质证明仅作为备案材料，中国羽毛球协会对学员提供的资质证明终生保留追责权利。</el-checkbox
                    >
                  </el-form-item>
                  <el-form-item label="" v-if="data[0].grade == 3">
                    <el-checkbox v-model="age18">我已年满18周岁</el-checkbox>
                  </el-form-item>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="培训通知" name="second">
              <div class="detail_top">
                <h3>{{ data[0].notice_title }}</h3>
                <p class="date">
                  创建时间:{{
                    data[0].createTime | dateformat("YYYY-MM-DD HH:mm")
                  }}
                </p>
              </div>
              <div class="detail_bottom" v-html="notice_content"></div>
            </el-tab-pane>
            <el-tab-pane label="考核内容" name="third">
              <el-table :data="data[0].contents" style="width: 80%">
                <el-table-column label="序号" width="70px">
                  <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                </el-table-column>
                <!--<el-table-column prop="teacher" label="教师" align="center"></el-table-column>
                <el-table-column prop="title" label="职称" align="center"></el-table-column>-->
                <el-table-column
                  prop="content"
                  label="培训内容"
                  align="center"
                ></el-table-column>
                <!--<el-table-column prop="time" label="学时数" align="center"></el-table-column>-->
                <el-table-column
                  prop="assessment_method"
                  label="考核方式"
                  align="center"
                ></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div style="text-align: center">
          <el-button type="danger" @click="signUp" :loading="loading">
            提交
          </el-button>
          <el-button type="danger" plain @click="goBack">返回</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetExaminerDetailsList, GetDicData } from "@/api/admin/common.js";
import { TrainClassSignUpList } from "@/api/admin/appraiser.js";
import { nowInDateBetwen, dateFormats } from "@/util/data.js";
let that = this;
export default {
  data() {
    return {
      data: [],
      notice_content: "",
      id: {},
      activeName: "first",
      imageUrl: "",
      active: "",
      dialogVisible: false,
      localFile: {},
      aptitude: "",
      imgaptitude: false,
      dialogImageUrl: "",
      appraiser_grade: [],
      form: {},
      isdisabled: false,
      checked: false,
      age18: false,
      loading: false,
      imgPath: window.apiObj.apiUrl,
      feeType: 3,
      feeTypeOptions: [
        {
          label: "培训+考核",
          value: 3,
        },
        {
          label: "培训",
          value: 1,
        },
        {
          label: "考核",
          value: 2,
        },
      ],
    };
  },
  created() {
    this.path();
    this.getList();
  },
  beforeCreate: function () {
    that = this;
  },
  watch: {
    aptitude(val) {
      if (!val) {
        this.imageUrl = "";
      }
    },
  },
  computed: {
    testFee() {
      return this.data[0].feeList.find((it) => it.value == this.feeType).label;
    },
  },
  methods: {
    path() {
      var pathList = [
        { title: "您当前的位置" },
        { title: "首页", path: "/index" },
        { path: "/evaluationStaffTraining", title: "考评员" },
        {
          path: "/evaluationStaffTraining",
          title: "考评员培训",
        },
        {
          title: "考评员培训详情",
          path: this.$route.fullPath,
        },
      ];
      setTimeout(() => {
        this.$store.commit("SET_ROUTELIST", pathList);
      });
    },
    getList() {
      this.id.id = this.$route.query.id;
      GetExaminerDetailsList(Object.assign(this.id)).then((data) => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          if (list.items[0].notice_content) {
            this.notice_content = list.items[0].notice_content.replace(
              new RegExp("/wwwroot", "gm"),
              this.imgPath
            );
          }
        }
      });
      GetDicData({ classCode: "appraiser_grade" }).then((data) => {
        if (data.data.result) {
          this.appraiser_grade = data.data.result;
        }
      });
    },
    change() {
      if (this.data[0].grade == 3) {
        this.imgaptitude = true;
      }
    },
    loadJsonFromFile(file) {
      this.localFile = file.raw;
      let reader = new FileReader();
      reader.readAsDataURL(this.localFile);
      reader.onload = () => {
        const isJPG =
          this.localFile.type === "image/jpeg" ||
          this.localFile.type === "image/png";
        const isLt4M = this.localFile.size / 1024 / 1024 < 4;
        if (!isJPG) {
          this.localFile = {};
          this.$message.error("上传图片只能是 JPG/PNG 格式!");
        } else {
          this.imageUrl = reader.result;
        }
        if (!isLt4M) {
          this.$message.error("上传图片大小不能超过 4MB!");
        }
        return isJPG && isLt4M;
      };
    },
    imgMouseover() {
      this.active = "display:block;opacity: 1;";
    },
    imgMouseleave() {
      this.active = "display:none;opacity: 0;";
    },
    handlePictureCardPreview() {
      this.dialogVisible = true;
      this.dialogImageUrl = this.imageUrl;
    },
    // handleClick(tab, event) {
    //   window.console.log(tab, event);
    // },
    handleRemove() {
      this.imageUrl = "";
      this.localFile = {};
      this.active = "display:none;opacity: 0;";
    },
    goBack() {
      this.$router.go(-1);
    },
    getDate(date) {
      var date1 = dateFormats(date);
      return date1;
    },
    signUp() {
      var timeStatus = nowInDateBetwen(
        this.getDate(new Date(this.data[0].startTime)),
        this.getDate(new Date(this.data[0].endTime)),
        this.getDate(new Date())
      );
      if (timeStatus) {
        this.activeName = "first";
        if (this.data[0].grade != 3) {
          if (!this.aptitude) {
            for (var i = 0; i < 1; i++) {
              if (this.aptitude === i) {
                continue;
              }
              this.$message({
                message: "请选择任意资质",
                type: "warning",
              });
              return;
            }
          } else if (this.aptitude > 0) {
            if (!this.imageUrl) {
              this.$message({
                message: "请上传资质图片",
                type: "warning",
              });
              return;
            }
          }
        } else {
          if (!this.age18) {
            this.$message({
              message: "请勾选报名提示",
              type: "warning",
            });
            return;
          }
        }
        // if (this.data[0].grade == 3) {
        //   if (!this.imageUrl) {
        //     this.$message({
        //       message: "请上传学历",
        //       type: "warning",
        //     });
        //     return;
        //   }
        // }
        if (!this.checked) {
          this.$message({
            message: "请勾选报名提示",
            type: "warning",
          });
          return;
        }

        this.$confirm("我已勾选所需选项，是否确认?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.form = {};
          this.form.isFormSubmit = true;
          this.form.tc_id = this.data[0].id;
          this.form.grade = this.data[0].grade;
          if (this.data[0].grade == 3) {
            this.form.aptitude_recording = "";
          } else {
            this.form.aptitude_recording = Number(this.aptitude);
            if (this.imageUrl) {
              this.form.aptitude_img = this.localFile;
            }
          }

          this.form.feeType = this.feeType;
          this.loading = true;
          // this.$router.push({
          //         path: "/evaluationStaff/evaluationStaffSignUp",
          //         query: { id: this.id.id }
          //       });
          TrainClassSignUpList(this.form)
            .then((data) => {
              const list = data.data.result;
              this.loading = false;
              if (list) {
                if (list.isSuccess) {
                  this.$message({
                    message: '报名信息已提交，审核中',
                    type: "warning",
                  });
                  // this.$router.push({
                  //   path: "/evaluationStaff/evaluationStaffSignUp",
                  //   query: { id: this.id.id },
                  // });
                } else {
                  this.$message({
                    message: list.errorMsg,
                    type: "warning",
                  });
                }
              }
            })
            .catch(() => {
              this.loading = false;
            });
        });
      } else {
        this.$message({
          message: "不在当前报名时间范围内",
          type: "warning",
        });
      }
    },
  },
  filters: {
    grade: (data) => {
      for (var i in that.appraiser_grade) {
        if (that.appraiser_grade[i].value == data) {
          return that.appraiser_grade[i].label;
        }
      }
    },
  },
};
</script>

<style lang="less">
.evaluationStaffTrainingDetail {
  .box-card {
    .content {
      padding-left: 20px;
      .el-form-item {
        margin-bottom: 0px;
        .avatar-uploader {
          position: relative;
        }
        .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 178px;
          height: 178px;
          line-height: 178px;
          text-align: center;
        }
        .avatar {
          width: 178px;
          height: 178px;
          display: block;
        }
        .el-upload-show {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          text-align: center;
          color: #fff;
          opacity: 0;
          display: none;
          font-size: 20px;
          background-color: rgba(0, 0, 0, 0.5);
          transition: opacity 0.3s;
          line-height: 9;
          .el-upload-span1 {
            span {
              padding: 0px 20px;
            }
          }
        }
        .friendshipTips {
          display: flex;
          p:nth-child(1) {
            padding: 0px 40px 0px 0px;
          }
          p:nth-child(2) {
            line-height: 5;
          }
        }
      }
    }
  }
  .detail_top {
    padding-top: 15px;
    width: 85%;
    margin: auto;
    h3 {
      text-align: center;
      font-size: 20px;
      font-weight: normal;
    }
    .date {
      text-align: center;
      font-size: 14px;
      color: #8a8a8a;
      margin: 20px 0 25px 0;
      border-bottom: 1px solid #cdcccc;
      padding-bottom: 15px;
    }
  }
  .detail_bottom {
    width: 85%;
    margin: auto;
  }
}
</style>
